import { SubscriptionDetail } from '@/pages/subscription-detail';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/subscription-detail/$productId')({
	component: SubscriptionDetail,
});
